/* eslint-disable */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import MeetingReasonOptions from "Data/MeetingReason.json";

const InitialMeetingModal = ({
  personName,
  setPersonName,
  setPersonId,
  setcomments,
  setmeetingReason,
}) => {
  const [meetingReasonValue, setmeetingReasonValue] = useState(null);
  const [meetingReasonString, setmeetingReasonString] = useState("");
  const [commentMessage, setcommentMessage] = useState("");

  const [reasonError, setreasonError] = useState(false);
  const [commentError, setcommentError] = useState(false);

  const scheduleHandler = () => {
    if (meetingReasonString != "") {
      setreasonError(false);
      setmeetingReason(meetingReasonString);
    } else {
      setreasonError(true);
    }

    if (commentMessage != "") {
      setcommentError(false);
      setcomments(commentMessage);
    } else {
      setcommentError(true);
    }

    if (meetingReasonString != "" && commentMessage != "") {
      let meetingModal = document.querySelector("#intial_meet_modal");
      let modal = bootstrap.Modal.getInstance(meetingModal);
      modal.hide();

      //show register modal
      let myModal = new bootstrap.Modal(
        document.getElementById("meeting_setup")
      );
      myModal.show();
    }

    setmeetingReasonString("");
    setcommentMessage("");
    setmeetingReasonValue(null);
  };

  const resetHandler = () => {
    setcommentError(false);
    setreasonError(false);
    setmeetingReasonString("");
    setcommentMessage("");
    if (setPersonName) {
      setPersonName("");
    }
    if (setPersonId) {
      setPersonId(null);
    }
    setcomments("");
    setmeetingReason("");
    setmeetingReasonValue(null);
  };

  return (
    <div className="conatct_modal">
      <div
        className="modal fade"
        id="intial_meet_modal"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="owner_hdngOuter d-flex align-items-center justify-content-between w-100">
                <h3 className="text-primary text-uppercase fs-lg">
                  {personName}
                  {/* <span className="online d-inline-block rounded-circle bg_green"></span> */}
                </h3>
                <button
                  type="button"
                  className="close rounded-circle"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={resetHandler}
                >
                  <i className="material-icons-outlined text-black">close</i>
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="owner_detailsOuter">
                <div className="form-group mb-4">
                  <label className="fw-bold mb-3 text-black fs-md">
                    Reason of meet
                  </label>
                  {/* <ul className="list_style_none checkbx_listing">
                    <li>
                      <label className="radio-check">
                        <input type="checkbox" />
                        <span></span>
                        <p className="fs-sm text-primary">Be your client</p>
                      </label>
                    </li>
                    <li>
                      <label className="radio-check">
                        <input type="checkbox" />
                        <span></span>
                        <p className="fs-sm text-primary">Be your supplier</p>
                      </label>
                    </li>
                    <li>
                      <label className="radio-check">
                        <input type="checkbox" />
                        <span></span>
                        <p className="fs-sm text-primary">Be your partner</p>
                      </label>
                    </li>
                    <li>
                      <label className="radio-check">
                        <input type="checkbox" />
                        <span></span>
                        <p className="fs-sm text-primary">I don't know</p>
                      </label>
                    </li>
                  </ul> */}
                  <Select
                    placeholder="Select reason of meet"
                    options={MeetingReasonOptions}
                    isClearable
                    value={meetingReasonValue}
                    onChange={(val) => {
                      setreasonError(false);
                      setmeetingReasonValue(val);
                      setmeetingReasonString(val.value);
                    }}
                  />
                  {reasonError && (
                    <p className="error">
                      <span className="material-icons-outlined">info</span>
                      Please select reason
                    </p>
                  )}
                </div>
                <div className="form-group description_fill mb-4">
                  <label className="fw-bold mb-3 text-black fs-md">
                    Comments
                  </label>
                  <textarea
                    className="form-control bg_white"
                    placeholder="Comment to meet"
                    value={commentMessage}
                    onChange={(e) => {
                      setcommentMessage(e.target.value);
                      setcommentError(false);
                    }}
                  ></textarea>
                  {commentError && (
                    <p className="error">
                      <span className="material-icons-outlined">info</span>
                      Please enter comment
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <Link
                    to="#"
                    // data-bs-toggle="modal"
                    // data-bs-target="#meeting_setup"
                    // data-bs-dismiss="modal"
                    className="btn primary-btn w-100"
                    onClick={scheduleHandler}
                  >
                    Schedule Meeting
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InitialMeetingModal;
